import React, { useState } from 'react'
import { Checkbox } from 'semantic-ui-react'

/**
 * Provides a stand-alone select widget that allows you to select a boolean for
 * positive NLP counts.
 */

type NameAndValue = {
  name: string
  value: boolean
}

type Props = {
  // Name of the select widget in a form context. Default: nlpConditionSelect
  name: string
  // Callback function on NLP count
  onChange: (
    e: any,
    nameAndValue: NameAndValue
  ) => void
  // Placeholder text. Default: NLP Encounters
  placeholder: string
  value: boolean
}

function NLPConditionSelect(
  props: Props
): JSX.Element {
  const {
    name: nameProp,
    onChange: onChangeProp,
    placeholder,
    value: hasValue
  } = props

  const [
    hasNLPConditionCount,
    setHasNLPConditionCount
  ] = useState<boolean>(false)

  const onChange = (
    e: any
  ): void => {
    const hasNewValue = !hasNLPConditionCount
    setHasNLPConditionCount(hasNewValue)
    if (onChangeProp) {
      const name = nameProp || 'nlpConditionCount'
      onChangeProp(e, { name, value: hasNewValue })
    }
  }

  return (
    <Checkbox
      id="nlp-condition-count"
      label={ placeholder || 'NLP Encounters Only' }
      onChange={ onChange }
      checked={ hasValue || undefined }
      toggle
    />
  )
}

export default NLPConditionSelect
